import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import ImageVersioningContext from 'context/ImageVersioningContext'
import Version from 'components/Version'
const Footer = ({ logo, message }) => {
  const { version } = useContext(ImageVersioningContext)

  return (
    <footer className="footer">
      <div className="footer__logo-message-container">
        {logo && <img alt="" className="footer__logo" src={`${logo}?${version}`} />}
        {message && <div className="footer__message">{message}</div>}
      </div>
      <Version className="footer__version" />
    </footer>
  )
}

Footer.propTypes = {
  logo: PropTypes.string,
  message: PropTypes.string,
}

export default Footer
